/**
 * Represents the status of an appointment.
 * The values should match the Java enum `AppointmentStatus`.
 */
export enum AppointmentStatus {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Ongoing = 'ONGOING',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  NoShow = 'NO_SHOW',
}
